'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventPropertySchema = exports.eventDefinitionSchema = exports.trackerPropertiesSchema = exports.trackerConfigSchema = exports.clientDependenciesSchema = exports.eventPropertyTypes = exports.eventClasses = undefined;

var _schema = require('./common/schema');

var schema = _interopRequireWildcard(_schema);

var _messages = require('./common/messages');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var eventClasses = exports.eventClasses = ['activation', 'creation', 'error', 'exposure', 'funnel', 'interaction', 'none', 'signup', 'usage', 'view', 'warning'];

var eventPropertyTypes = exports.eventPropertyTypes = ['boolean', 'string', 'number', 'array'];

/*
 *  Schema for createClient() function args
 */
var clientDependenciesSchema = exports.clientDependenciesSchema = schema.create('client dependency', _messages.configError, {
  clientName: {
    types: ['string'],
    default: 'custom'
  },
  getDebug: {
    types: ['function']
  },
  getEmail: {
    types: ['function']
  },
  getHubId: {
    types: ['function']
  },
  getHstc: {
    types: ['function']
  },
  getLang: {
    types: ['function']
  },
  getTempStorage: {
    types: ['function']
  },
  setTempStorage: {
    types: ['function']
  },
  logMessage: {
    types: ['function'],
    default: function _default(msg) {
      return console.log(msg);
    }
  },
  logError: {
    types: ['function'],
    default: function _default(err) {
      return console.error(err);
    }
  },
  reportError: {
    types: ['function']
  },
  send: {
    types: ['function']
  }
});

/*
 *  Schema for createTracker() function args
 */
var trackerConfigSchema = exports.trackerConfigSchema = schema.create('config option', _messages.configError, {
  events: {
    types: ['object']
  },
  properties: {
    types: ['object'],
    default: {}
  },
  debug: {
    types: ['boolean', 'function']
  },
  onError: {
    types: ['function']
  },
  allowUnauthed: {
    types: ['boolean'],
    default: false
  },
  bypassPool: {
    types: ['boolean'],
    default: false
  },
  isBeforeUnload: {
    types: ['boolean'],
    default: false
  },
  isExternalHost: {
    types: ['boolean'],
    default: false
  },
  recordTrackedEventKeys: {
    types: ['boolean'],
    default: false
  },
  lastKnownEventProperties: {
    types: ['array'],
    default: []
  },
  preserveTrackerProperties: {
    types: ['boolean'],
    default: true
  }
});

/*
 *  Schema for tracker properties
 */
var trackerPropertiesSchema = exports.trackerPropertiesSchema = schema.create('tracker properties', _messages.configError, {
  email: {
    types: ['string', 'function', 'object']
  },
  hubId: {
    types: ['number', 'function', 'object']
  },
  hstc: {
    types: ['string', 'function', 'object']
  },
  lang: {
    types: ['string', 'function', 'object']
  }
}, false);

/*
 *  Schema for events.yaml definitions
 */
var eventDefinitionSchema = exports.eventDefinitionSchema = schema.create('event property', _messages.configError, {
  name: {
    types: ['string']
  },
  namespace: {
    types: ['string'],
    default: ''
  },
  class: {
    types: ['string'],
    oneOf: eventClasses
  },
  version: {
    types: ['string'],
    default: 'v1'
  },
  properties: {
    types: ['object'],
    default: {}
  }
});

/*
 *  Schema for events.yaml event properties
 */
var eventPropertySchema = exports.eventPropertySchema = schema.create('event property', _messages.configError, {
  type: {
    types: ['string', 'array'],
    oneOf: eventPropertyTypes
  },
  isOptional: {
    types: ['boolean'],
    default: false
  }
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.319/js/schemas.js
// module id = 129
// module chunks = 177